module.exports = __webpack_public_path__ + "img/memo-solid.d841840f.svg";